import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

const BlueBox = styled(Box)(({ theme }) => ({
    marginLeft: 28,
    marginRight: 28,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    verticalAlign: 'center',
    backgroundColor: theme.palette.text.secondary,
    height: '45px',
    width: '80px',
    textAlign: 'center'
}));

export default BlueBox;